<template>
  <div class="inner-container" :class="{ 'min-container': !getTabs }">
    <div class="page-header">
      <h1>{{ $t("CATEGORIES") }}</h1>
      <b-button
        size="sm"
        variant="success"
        class="button-succes-style ml-2 float-right mb-2"
        @click="handleStore"
        ><font-awesome-icon icon="plus-circle" /> {{ $t("NEW") }}</b-button
      >
    </div>

    <storeModalVue @updateList="setup(true)"></storeModalVue>

    <div class="content">
      <div class="content-header">
        <searchBar
          :searchFunc="allprestation"
          :searchText="$t('CATEGORY_SEARCH')"
          :filtre="{
            with_default: filtre_default,
            entreprise: filtre_entreprise ? filtre_entreprise.id : null,
          }"
          :showFiltre="true"
          @returnValue="updateSearch($event)"
        ></searchBar>

        <b-modal id="entrepriseModal" ref="entrepriseModal">
          <template #modal-header="{ close }">
            <h5>{{ $t("COMPANY_ID") }}</h5>
            <b-button size="sm" @click="close()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17.028"
                height="17.028"
                viewBox="0 0 17.028 17.028"
              >
                <path
                  id="Icon_material-close"
                  data-name="Icon material-close"
                  d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                  transform="translate(-7.5 -7.5)"
                  fill="#393939"
                />
              </svg>
            </b-button>
          </template>

          <form @submit.prevent="hideModal('entrepriseModal')">
            <div class="center">
              <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
                <searchInput
                  :list="getAllentreprises"
                  :loader="getentrepriseLoading"
                  label="lib"
                  :searchFunc="all_entreprises"
                  @searchfilter="selectentreprise($event)"
                ></searchInput>
              </b-form-group>
              <b-form-group>
                <b-form-checkbox
                  v-model="filtre_default"
                  :value="1"
                  :unchecked-value="0"
                >
                  {{ $t("SHOW_PUBLIC") }}
                </b-form-checkbox>
              </b-form-group>
            </div>
          </form>
          <template #modal-footer>
            <div class="actionModel">
              <b-button variant="success" @click="setup(true)">
                <div class="block-spinner">
                  {{ $t("Appliquer") }}
                </div>
              </b-button>
            </div>
          </template>
        </b-modal>
      </div>
      <div class="filtre">
        <p class="table-count">
          {{ getTotalRowPrestation }} {{ $t("CATEGORIES") }}
        </p>
        <div class="productTrie" v-if="currententreprise.lib != null">
          {{ currententreprise.lib }}
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="
              filtre_entreprise = {
                lib: null,
              };
              setup(true);
            "
          />
        </div>

        <div class="productTrie" v-if="currentDefault == 1">
          Voir {{ $t("CATEGORIES") }} publiques
          <font-awesome-icon
            icon="times-circle"
            class="icons"
            @click="
              filtre_default = null;
              setup(true);
            "
          />
        </div>
      </div>
      <div class="table-rapport-style w-100">
        <table>
          <thead>
            <tr>
              <th v-if="isSuperAdmin" style="border-radius: 0px 5px 0px 0px">
                {{ $t("SOCIETY") }}
              </th>
              <th style="border-radius: 0px 5px 0px 0px">
                {{ $t("WORDING") }}
              </th>
              <th class="action_head"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              role="row"
              class="ligneNormale"
              v-for="(data, i) in getAllprestation"
              :key="i"
              @click="handleUpdate(data)"
              :class="{ default_element: data.is_default }"
            >
              <td v-if="isSuperAdmin" aria-colindex="1" role="cell">
                {{ data.entreprise.lib }}
              </td>
              <td aria-colindex="1" role="cell">
                <font-awesome-icon
                  icon="fa-solid fa-bookmark"
                  class="icons"
                  v-if="data.is_default"
                />
                {{ data.lib }}
              </td>
              <td
                aria-colindex="3"
                role="cell"
                class="action_col"
                v-if="!data.is_default || (data.is_default && isSuperAdmin)"
              >
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="danger"
                  @click.prevent.stop="handleDelete(data)"
                >
                  <font-awesome-icon icon="trash" />
                </b-button>
                <b-button
                  class="button-succes-style"
                  size="sm"
                  variant="success"
                  @click.prevent.stop="handleUpdate(data)"
                >
                  <font-awesome-icon icon="pencil-alt" />
                </b-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <b-modal
        id="ModelConfigPrestation"
        ref="ModelConfigPrestation"
        hide-footer
        @hide="v$.$reset()"
      >
        <template #modal-header>
          <h5>{{ $t("EDIT") }} {{ $t("CATEGORIES") }}</h5>
          <b-button size="sm" @click="resetModal()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.028"
              height="17.028"
              viewBox="0 0 17.028 17.028"
            >
              <path
                id="Icon_material-close"
                data-name="Icon material-close"
                d="M24.528,9.215,22.813,7.5l-6.8,6.8-6.8-6.8L7.5,9.215l6.8,6.8-6.8,6.8,1.715,1.715,6.8-6.8,6.8,6.8,1.715-1.715-6.8-6.8Z"
                transform="translate(-7.5 -7.5)"
                fill="#393939"
              />
            </svg>
          </b-button>
        </template>
        <form @submit.prevent="PrestationModalNew" v-if="PrestationToConfig">
          <div class="center">
            <b-form-group :label="$t('WORDING')" label-for="lib">
              <b-form-input
                id="lib"
                v-model="v$.PrestationToConfig.lib.$model"
                maxlength="40"
                :state="validateState('lib')"
                oninput="this.value = this.value.toUpperCase()"
                aria-describedby="lib-feedback"
              ></b-form-input>
              <error-handle
                :list="v$.PrestationToConfig.lib.$errors"
                id="lib-feedback"
              ></error-handle>
              <div v-if="erreurlist.lib" class="error-message">
                <ul v-if="Array.isArray(erreurlist.lib)">
                  <span v-for="(e, index) in erreurlist.lib" :key="index">
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.lib }}</span>
              </div>
            </b-form-group>

            <b-form-group :label="$t('COMPANY_ID')" v-if="isSuperAdmin">
              <multiselect
                v-model="PrestationToConfig.entreprise"
                :searchable="true"
                :close-on-select="true"
                :multiple="false"
                :options="computedAllentreprises"
                label="lib"
                track-by="id"
              >
                <template slot="noResult"> {{ $t("NO_DATA_FOUND") }} </template>
              </multiselect>
              <div v-if="erreurlist.entreprise_id" class="error-message">
                <ul v-if="Array.isArray(erreurlist.entreprise_id)">
                  <span
                    v-for="(e, index) in erreurlist.entreprise_id"
                    :key="index"
                  >
                    {{ e }}
                  </span>
                </ul>
                <span v-else>{{ erreurlist.entreprise_id }}</span>
              </div>
            </b-form-group>
          </div>

          <div class="actionModel">
            <b-alert variant="warning" show v-if="errorU" class="messageError">
              {{ errorU }}
            </b-alert>
            <b-button
              variant="success"
              type="submit"
              class="succes-btn-modal btn-success"
            >
              <div class="block-spinner">
                {{ $t("EDIT") }}
                <div v-if="getLoadingprestation" class="loading ml-2">
                  <div class="spinner-border" role="status"></div>
                </div>
              </div>
            </b-button>
          </div>
        </form>
      </b-modal>

      <deleteModalVue
        :loader="getLoadingprestation"
        :elemToDelete="PrestationToDelete"
        :elemDelete="delete_prestation"
        @updateList="setup(false)"
      ></deleteModalVue>

      <b-pagination
        v-if="search == ''"
        v-model="page"
        :total-rows="getTotalRowPrestation"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
      <b-pagination
        v-else
        v-model="page"
        :total-rows="getTotalRowPrestation"
        :per-page="perPage"
        aria-controls="my-table"
        pills
        last-number
        first-number
        align="center"
        size="sm"
        @change="pagination"
        class=""
      ></b-pagination>
    </div>

    <div class="text-center center-spin">
      <b-spinner
        v-if="getLoadingprestation"
        variant="primary"
        label="Spinning"
        class="big-spin"
      ></b-spinner>
    </div>
    <CommentMarche></CommentMarche>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import searchInput from "@/components/ui/searchInput";
import { useVuelidate } from "@vuelidate/core";
import { required, maxLength } from "@vuelidate/validators";
import deleteModalVue from "../components/ui/deleteModal.vue";
import storeModalVue from "../components/Ajoutmodel/categoriemodale.vue";
import searchBar from "../components/ui/searchBar.vue";
import errorHandle from "../components/ui/errorHandle.vue";
import CommentMarche from "../components/commentMarche.vue";

export default {
  setup() {
    return { v$: useVuelidate({ $lazy: true, $autoDirty: true }) };
  },
  components: {
    searchBar,
    searchInput,
    deleteModalVue,
    storeModalVue,
    errorHandle,
    CommentMarche,
  },
  data() {
    return {
      search: "",
      PrestationToConfig: null,
      PrestationToDelete: null,
      page: 1,
      perPage: 10,
      errorD: false,
      errorS: false,
      errorU: false,
      currententreprise: {
        id: null,
      },
      optionDefault: [
        { value: null, text: "cacher categories publics" },
        { value: 1, text: "Voir categories publics" },
      ],
      currentDefault: null,
      filtre_default: null,
      filtre_entreprise: {
        id: null,
      },
      erreurlist: {
        lib: null,
        entreprise_id: null,
      },
    };
  },
  validations() {
    return {
      PrestationToConfig: {
        lib: { required, maxLength: maxLength(100) },
      },
    };
  },
  methods: {
    ...mapActions([
      "edit_prestation",
      "allprestation",
      "delete_prestation",
      "all_entreprises",
    ]),

    validateState(name) {
      const { $dirty, $error } = this.v$.PrestationToConfig[name];
      return $dirty ? !$error : null;
    },

    updateSearch(s) {
      this.page = 1;
      this.search = s;
    },

    selectentreprise(query) {
      if (query) {
        this.filtre_entreprise = query;
      } else {
        this.filtre_entreprise = {
          lib: null,
        };
      }
      this.setup(true);
      this.hideModal("entrepriseModal");
    },
    resetModal() {
      this.erreurlist = {
        lib: null,
        entreprise_id: null,
      };
      this.errorU = null;
      this.hideModal("ModelConfigPrestation");
    },
    async searchprestation() {
      await this.allprestation({
        page: this.page,
        per_page: this.perPage,
        search: this.search,
        with_default: this.filtre_default,
        entreprise: this.filtre_entreprise.id,
      });
    },
    hideModal(ref) {
      this.$refs[ref].hide();
    },
    handleUpdate(CAT) {
      this.PrestationToConfig = { ...CAT };
      this.$refs["ModelConfigPrestation"].show();
    },
    handleDelete(CAT) {
      this.PrestationToDelete = { ...CAT };
      this.$root.$emit("bv::show::modal", "ModelDelete");
    },
    async PrestationModalNew() {
      const isFormCorrect = await this.v$.PrestationToConfig.$error;
      if (isFormCorrect) return;
      this.erreurlist = {
        lib: null,
        entreprise_id: null,
      };
      this.errorU = null;
      await this.edit_prestation({
        lib: this.PrestationToConfig.lib,
        id: this.PrestationToConfig.id,
        categorie: this.PrestationToConfig.categorie,
        lang: "fr",
        entreprise_id: this.PrestationToConfig.entreprise
          ? this.PrestationToConfig.entreprise.id
          : this.getOnlineUser.entreprise.id,
      })
        .then(() => {
          this.hideModal("ModelConfigPrestation");
          this.errorU = null;
        })
        .catch((err) => {
          if (this.isObject(err)) {
            for (const [key, value] of Object.entries(err)) {
              if (!this.erreurlist[key]) {
                this.erreurlist[key] = value;
              }
            }
          } else {
            this.errorU = err;
          }
        });
    },
    isObject(obj) {
      return Object.prototype.toString.call(obj) === "[object Object]";
    },
    async PrestationDelete() {
      await this.delete_prestation({
        id: this.PrestationToDelete.id,
      })
        .then(() => {
          this.hideModal("ModelDeletePrestation");
          this.errorD = null;
        })
        .catch((err) => {
          this.errorD = err;
        });
    },
    handleStore() {
      this.$root.$emit("bv::show::modal", "PrestationModal");
    },
    pagination(paginate) {
      this.page = paginate;
      this.searchprestation();
    },

    setup(refresh = false) {
      if (refresh) this.page = 1;
      this.search = null;
      this.currentDefault = this.filtre_default;
      this.currententreprise = this.filtre_entreprise;
      this.$refs["entrepriseModal"].hide();

      if (this.getOnlineUser) {
        if (this.isSuperAdmin) {
          this.allprestation({
            page: this.page,
            per_page: this.perPage,
            with_default: this.filtre_default,
            entreprise: this.filtre_entreprise.id,
          });
        } else {
          this.allprestation({
            page: this.page,
            per_page: this.perPage,
            entreprise: this.getOnlineUser.entreprise.id,
            with_default: this.filtre_default,
          });
        }
      }
    },
  },

  mounted() {
    this.setup(true);
    if (this.isSuperAdmin)
      this.all_entreprises({
        search: this.search,
        page: 1,
        per_page: 10,
      });
  },

  computed: {
    ...mapGetters([
      "getAllprestation",
      "getLoadingprestation",
      "getTotalRowPrestation",
      "getTabs",
      "getOnlineUser",
      "getAllentreprises",
      "getentrepriseLoading",
    ]),

    isSuperAdmin() {
      return this.getOnlineUser.role == "user.super-admin";
    },
    computedAllentreprises() {
      var list = [
        {
          lib: "TOUTES LES ENTREPRISES",
          id: 1,
        },
      ];
      if (this.getAllentreprises)
        this.getAllentreprises.forEach((element) => {
          if (element.id != 1) list.push(element);
        });
      return list;
    },
  },
};
</script>
<style lang="scss" scoped>
.input-group .icon-balance {
  top: 8px;
}
.body {
  padding: 4px 0;
  box-shadow: 1px 1px 8px #00000019;
  max-height: 60vh;
  overflow: auto;

  ul {
    list-style: none;
    & li {
      padding: 8px 0;
      cursor: pointer;
      background-color: #f8f8f8;
      margin-bottom: 4px;
      color: #000;
      border: none;
      box-shadow: none;
      transition: all 0.2s ease;
      text-align: center;

      &:hover {
        background-color: #28367a;
        color: #fff;
      }
    }
  }
}
.content {
  & p {
    font-size: 12px;
    font-weight: 500;
    padding: 3px 0;
    margin: 0;
  }
}

.w-100 {
  background-color: #f8f8f8;
  padding: 4px;
  overflow-x: auto;
}

body {
  background: #fafdff;
}

.actionModel {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2px 0;
  align-items: center;
  .messageError {
    top: 5px;
    bottom: 44px;
    color: #e4261b;
    font-size: 15px;
    background-color: #fff;
    border-color: #fff;
  }
  & .block-spinner {
    display: flex;
    justify-content: center;
  }

  & .spinner-border {
    width: 1.5rem;
    height: 1.5rem;
  }
}
.filtre {
  display: flex;
  align-items: center;

  .table-count,
  .productTrie {
    margin-right: 15px;
  }

  .productTrie {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    overflow: hidden;
    padding: 4px 8px;
    border-radius: 32px;
    background-color: #34c38f;
    color: #fff;

    .icons {
      cursor: pointer;
      width: 18px;
      height: 18px;
      margin-left: 4px;
    }
  }
}
</style>
